import {WhitelabelEvent} from "../../../../common/ts/events/Events";

export class ShowGoogleOneTapRequestedEvent implements WhitelabelEvent {
    type: string;
    static readonly TYPE: string = 'show-google-one-tap-requested';

    constructor() {
        this.type = ShowGoogleOneTapRequestedEvent.TYPE;
    }
}